import React, { useState } from "react";
import { Container, Row, Col, Form, Button } from "react-bootstrap";
import { CgPhone , CgMail } from "react-icons/cg";
import { CiLocationOn } from "react-icons/ci";
import Particle from "../Particle";

const Contact = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    title: "",
    message: ""
  });

  const handleChange = (e) => {
    const { id, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [id]: value
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    alert("Thanks for contacting us!");

    setFormData({
      name: "",
      email: "",
      title: "",
      message: ""
    });
  };

  return (
    <>
      <section className="section-white contact-section" id="contact-us">
        <Particle />
        <Container>
          <div className="sections-top-content text-center mb-4">
          <h3 className="project-heading"><span className="purple">CONTACT US</span></h3>
            <p className="text-white">
              <strong>Get in touch with us, and we will reply within 24 hours.</strong><br />
              <span className="mt-5 d-block"></span>
              We appreciate you contacting <strong className="purple">Youkish Tech!</strong> Please complete the form below, and
              we will make sure to offer fast and effective service. If your issue is urgent, please reach out to our Customer Support team.
            </p>
          </div>

          <Row>
            <Col md={4}>
              <div className="contact-container text-center text-white">
                <CgMail style={{ color: "#c770f0", fontSize: "30px", marginBottom: "12px" }} />
                <p>youkishtech@gmail.com</p>
              </div>
            </Col>
            <Col md={4}>
              <div className="contact-container text-center text-white">
              <CiLocationOn  style={{ color: "#c770f0", fontSize: "30px", marginBottom: "12px" }} />
                <p>78A, Ground Floor, Gazali Road, Block 2, PECHS, Karachi Pakistan</p>
              </div>
            </Col>
            <Col md={4}>
              <div className="contact-container text-center text-white">
              <CgPhone style={{ color: "#c770f0", fontSize: "30px", marginBottom: "12px" }} />
              <p>+92 3219212340</p>
              </div>
            </Col>
          </Row>
        </Container>
        <section className="section-grey form-section py-5">
          <Container>
            <Form onSubmit={handleSubmit} className="contact-form">
              <Row>
                <Col className="mt-3" md={4} sm={4}>
                  <Form.Group className="form-fields">
                    <Form.Control
                      type="text"
                      id="name"
                      placeholder="Name"
                      value={formData.name}
                      onChange={handleChange}
                      required
                      className="input-fields"
                    />
                  </Form.Group>
                </Col>
                <Col className="mt-3" md={4} sm={4}>
                  <Form.Group className="form-fields">
                    <Form.Control
                      type="email"
                      id="email"
                      placeholder="Email"
                      value={formData.email}
                      onChange={handleChange}
                      required
                      className="input-fields"
                    />
                  </Form.Group>
                </Col>
                <Col className="mt-3" md={4} sm={4}>
                  <Form.Group className="form-fields">
                    <Form.Control
                      type="text"
                      id="title"
                      placeholder="Subject"
                      value={formData.title}
                      onChange={handleChange}
                      required
                      className="input-fields"
                    />
                  </Form.Group>
                </Col>
                <Col md={12} className="mt-3">
                  <Form.Group>
                    <Form.Control
                      as="textarea"
                      rows={10}
                      id="message"
                      placeholder="Message"
                      value={formData.message}
                      onChange={handleChange}
                      required
                    />
                  </Form.Group>
                </Col>
                <Col md={12} className="text-center mt-3">
                  <Button type="submit" className="sections-btn">Submit Now</Button>
                </Col>
              </Row>
            </Form>
          </Container>
        </section>
      </section>
    </>
  );
};

export default Contact;
